/* @flow */

import { detect } from 'detect-browser';

const debug = require('debug')('browserUtil');

/**
 * Scroll to the top of the window
 * @return {undefined}
 */
export function scrollToTop(): void {
  window.scrollTo(0, 0);
}

/**
 * Scroll to the bottom of the window
 * @param {HTMLElement} element Element to scroll, used with overflow: scroll/auto
 * @return {undefined}
 */
export function scrollToBottom(element: ?HTMLElement): void {
  if (element) {
    element.scrollTo(0, element.scrollHeight);
  } else {
    // $FlowIssue: no use case exists where document.body is null
    window.scrollTo(0, document.body.scrollHeight);
  }
}

/**
 * Disable body scrolling
 * @return {undefined}
 */
export function disableBodyScrolling(): void {
  // $FlowIssue: no use case exists where document.body is null
  document.body.style.overflow = 'hidden';
}

/**
 * Enable body scrolling
 * @return {undefined}
 */
export function enableBodyScrolling(): void {
  // $FlowIssue: no use case exists where document.body is null
  document.body.style.overflow = 'visible';
}

/**
 * Check whether OS is Android
 * @return {boolean} True if it is
 */
export function isAndroid(): boolean {
  return !!navigator.userAgent.match(/android/i);
}

/**
 * Check whether browser is IE
 * @return {boolean} True if it is
 */
export function isIE() {
  if (
    typeof window !== 'undefined' &&
    window.navigator &&
    typeof window.navigator === 'object' &&
    typeof window.navigator.userAgent === 'string' &&
    typeof window.navigator.appVersion === 'string'
  ) {
    return (
      window.navigator.userAgent.indexOf('MSIE') !== -1 ||
      window.navigator.appVersion.indexOf('Trident/') > 0
    );
  }
}

export function isIE11() {
  if (typeof window !== 'undefined') {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
}

/**
 * Check whether OS is iOS
 * @return {boolean} True if it is
 */
export function isiOS(): ?boolean {
  if (
    typeof window !== 'undefined' &&
    window.navigator &&
    typeof window.navigator === 'object' &&
    typeof window.navigator.userAgent === 'string'
  ) {
    return !!(
      window.navigator.userAgent.match(/iPad|iPhone|iPod/) && !window.MSStream
    );
  }
}

// See https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari/29696509#29696509
export function isiOSSafari(): ?boolean {
  if (
    typeof window !== 'undefined' &&
    window.navigator &&
    typeof window.navigator === 'object' &&
    typeof window.navigator.userAgent === 'string'
  ) {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    return iOSSafari;
  }
}

export const browser = {
  isBrowser(name: string) {
    const browser = detect();
    debug('Detect browser', browser);
    return browser.name === name;
  },
  isEdge() {
    return this.isBrowser('edge');
  },
  isChrome() {
    return this.isBrowser('chrome');
  },
  isiOs() {
    return this.isBrowser('ios');
  },
  isSafari() {
    return this.isBrowser('ios') || this.isBrowser('safari');
  },
};

export const getBrowserInfo = () => {
  const browser = detect();
  const { name, version, os } = browser;
  return `${name} ${version} (${os})`;
};
